'use client'

import Script from 'next/script'

export function GoogleAnalytics() {
  return (
    <>
      <Script
        id='google-analytics'
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-2LB6TPRLF4');
          `,
        }}
      />
      <Script src='https://www.googletagmanager.com/gtag/js?id=G-2LB6TPRLF4' />
    </>
  )
}
